import { render, staticRenderFns } from "./HelpContactTile.vue?vue&type=template&id=528fd402&scoped=true&"
import script from "./HelpContactTile.vue?vue&type=script&lang=ts&"
export * from "./HelpContactTile.vue?vue&type=script&lang=ts&"
import style0 from "./HelpContactTile.vue?vue&type=style&index=0&id=528fd402&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "528fd402",
  null
  
)

export default component.exports